import React, { useEffect, useState, useRef, useMemo } from "react";
import axiosInstance from "../../../utils/axiosInstance";
import { useParams } from "react-router-dom";
import moment from "moment";
import $ from "jquery";
import "datatables.net-bs4/js/dataTables.bootstrap4.js";
import "datatables.net-bs4/css/dataTables.bootstrap4.css";

import "datatables.net-responsive-bs4/js/responsive.bootstrap4.js";
import "datatables.net-responsive-bs4/css/responsive.bootstrap4.css";


const BetDetailsPopup = ({ }) => {
  const { transid } = useParams();
  const [username, setUsername] = useState("-");
  const [eventName, setEventName] = useState("-");
  const [displayTitle, setDisplayTitle] = useState("");
  const [winAmount, setWinAmount] = useState(0);
  const [resultValue, setResultValue] = useState("");
  const [betList, setBetList] = useState([]);
  const [settledAt, setSettledAt] = useState("");

  const tableRef = useRef(null);

  const getHistory = async (transid) => {
    try {
      const response = await axiosInstance.post("/profit-loss/trans-details", {
        transid
      });
      console.log("Fetching profile and loss details response:", response.data);
      debugger;
      let recordList = response.data.recordList;

      if (
        recordList !== null &&
        recordList !== undefined &&
        recordList.length > 0
      ) {
        let recordObj = recordList[0];

        setUsername(recordObj.uname);
        setResultValue(recordObj.result);

        if (
          (recordObj.game_type == 1 ||
            recordObj.game_type == 2 ||
            recordObj.game_type == 3) &&
          (recordObj.market_type == 1 || recordObj.market_type == 2)
        ) {
          let displayTitleTxt = "";
          if (recordObj.market_type == 2) {
            displayTitleTxt = recordObj.remark + "(Bookmaker)";
          } else {
            displayTitleTxt = recordObj.remark + "(Match ODD)";
          }
          setDisplayTitle(displayTitleTxt);
        } else {
          let displayTitleTxt = recordObj.event_name + "-" + recordObj.remark;

          setDisplayTitle(displayTitleTxt);
        }

        if (recordObj.game_type == 1 && recordObj.market_type == 6) {
          let betObjList = recordObj.betList;
          if (
            betObjList !== null &&
            betObjList !== undefined &&
            betObjList.length > 0
          ) {
            let betArray = [];
            for (let j = 0; j < betObjList.length; j++) {
              let bet = betObjList[j];
              let newBetObj = {};
              newBetObj.section = bet.bet_number;
              newBetObj.rate = bet.odd;
              newBetObj.lib = Math.abs(bet.bet_amount);
              newBetObj.type = "b";
              newBetObj.amnt = bet.win_amount;
              newBetObj.stmp = bet.creation_date;
              newBetObj.settledAt = bet.settled_date;
              newBetObj.id = bet.id;
              newBetObj.result_number = bet.result_number;
              newBetObj.is_loss = bet.is_loss;

              betArray.push(newBetObj);
            }
            setBetList(betArray);
          }
        } else {
          setBetList(recordObj.betList);
        }

        setSettledAt(recordObj.created_date);

        setWinAmount(Math.round(recordObj.amount));
        setIsLoading(false);
      }
    } catch (error) {
      console.error("Error fetching trans details:", error);
    }
  };

  //Get Event Details By CatMid
  useEffect(() => {
    getHistory(transid);
  }, []); // Empty dependency array

  const gridTableRef = useRef(null);

  const [isLoading, setIsLoading] = useState(true);
  const [pageSize, setPageSize] = useState(1000);
  const loadingRef = useRef(false);

  const defaultExpand = false;
  const cols = useMemo(
    () => [
      {
        title: "#",
        data: null,
        orderable: false,
        responsivePriority: 1,
        render: (data, type, row, meta) => `
        <div class="d-flex align-items-center gap-2">
          <span class="seq-number">${meta.row + 1}</span>
          <button type="button" class="toggle-row toggle-closed">+</button>
        </div>
      `
      },
      {
        title: "Runner",
        data: "section",
        responsivePriority: 2,
        render: (d) =>
          `<span style='font-size:14px;font-weight:500;'>${d}</span>`
      },
      {
        title: "Price",
        data: "rate",
        responsivePriority: 3,
        render: (d) => `<span>${d}</span>`
      },
      {
        title: "Size",
        data: "lib",
        responsivePriority: 4,
        render: (d, type, row, meta) => getSize(row)
      },
      {
        title: "Side",
        data: "type",
        responsivePriority: 5,
        render: (d) => {
          const bg =
            d === "y" || d === "b" || d === "B" || d === "Y"
              ? "#17a2b8" // Back
              : "#dc3546"; // Lay
          return `<div style="display:block;padding:4px;background:${bg};color:white;text-align:center;font-weight:bold;">
          ${d?.toUpperCase()}
        </div>`;
        }
      },
      {
        title: "P/L",
        data: "amnt",
        responsivePriority: 6,
        render: (d, type, row, meta) => getWinLoss(row)
      },
      {
        title: "Placed At",
        data: "stmp",
        responsivePriority: 7,
        render: (d) =>
          d ? moment.utc(d).local().format("DD/MM/YYYY HH:mm:ss") : ""
      },
      {
        title: "Matched At",
        data: "stmp",
        responsivePriority: 8,
        render: (d) =>
          d ? moment.utc(d).local().format("DD/MM/YYYY HH:mm:ss") : ""
      },
      {
        title: "Settled At",
        data: "settledAt",
        responsivePriority: 9,
        render: (d) =>
          d ? moment.utc(d).local().format("DD/MM/YYYY HH:mm:ss") : ""
      },
      {
        title: "Order-ID",
        data: "id",
        responsivePriority: 10,
        render: (d) => `<span>${d}</span>`
      },
      {
        title: "is_loss",
        data: "is_loss",
        visible: false,
        responsivePriority: 10,
        render: (d) => `<span>${d}</span>`
      }
    ],
    []
  );

  useEffect(() => {
    // Don't initialize DataTable while loading or if no data
    if (isLoading || !betList.length) return;

    const $table = $(gridTableRef.current);
    if (!$table.length) return;

    // Clean up any existing DataTable properly
    if ($.fn.dataTable.isDataTable($table)) {
      const dt = $table.DataTable();
      // Remove all event listeners first
      $table.off("click", "button.toggle-row");
      dt.off("order.dt search.dt draw.dt");
      dt.off("responsive-resize draw");
      // Destroy the DataTable
      dt.destroy(true);
      $table.empty();
    }

    // Normalize column definitions (support data/title and legacy mData/sTitle)
    const normalizedCols = (cols || []).map((c) => ({
      ...c,
      title: c.title || c.sTitle || "",
      data: c.data || c.mData || c.name || "",
      orderable: typeof c.orderable === "boolean" ? c.orderable : true
    }));

    // Ensure first column (seq/#) is not orderable and has a consistent renderer
    if (normalizedCols[0]) {
      normalizedCols[0].orderable = false;
      // Ensure seq column has a render that places a span.seq-number we can update later
      const originalRender = normalizedCols[0].render;
      normalizedCols[0].render = function (data, type, row, meta) {
        // For ordering/searching we should return numeric value; for display return HTML
        if (type === "display" || type === "filter") {
          const seqHTML = `<div class="seq-cell d-flex align-items-center gap-1">
            <span class="seq-number">${typeof data === "number" ? data : ""
            }</span>
            <button type="button" class="toggle-row toggle-closed" style="display:none;">+</button>
          </div>`;
          // If user provided an original render, respect it for display of the number placeholder
          return originalRender
            ? originalRender(data, type, row, meta)
            : seqHTML;
        }
        // For other types (order/search) return a stable numeric value if available
        return typeof data === "number" ? data : 0;
      };
    }

    // Compute initial order from columns (supports col.order = "asc"|"desc")
    const initialOrder = [];
    normalizedCols.forEach((col, idx) => {
      if (
        col.order &&
        ["asc", "desc"].includes(String(col.order).toLowerCase())
      ) {
        initialOrder.push([idx, col.order]);
      }
    });

    // Build safe betList (only include referenced keys + seq)
    const keys = normalizedCols.map((c) => c.data).filter(Boolean);
    const safeData = (betList || []).map((row, i) => {
      const out = { seq: i + 1 };
      keys.forEach((k) => {
        if (k in row) out[k] = row[k];
      });

      // Inject settledAt from state
      out.settledAt = settledAt;

      return out;
    });

    let dt;
    try {
      dt = $table.DataTable({
        data: safeData,
        columns: normalizedCols,
        responsive: { details: false },
        paging: false,
        info: false,
        lengthChange: false,
        autoWidth: false,
        ordering: true,
        order: initialOrder,
        columnDefs: [{ targets: 0, orderable: false }], // safeguard
        dom: '<"top d-flex flex-wrap justify-content-between align-items-center" <"dataTables_length"l> <"dt-search"f> <"dt-buttons"> >rt<"bottom d-flex justify-content-between align-items-center"ip><"clear">',

        language: {
          paginate: { previous: "&laquo;", next: "&raquo;" }
        },
        orderClasses: false,
        rowCallback: function (row, data, index) {
          // Mobile breakpoint (same as your CSS media query)
          const isMobile = window.matchMedia("(max-width:640px)").matches;

          if (isMobile) {
            // single dark color for every main row on mobile
            $(row).css({
              "background-color": "#f7f7f7", // dark row background
              color: "#ffffff" // light text
            });
          } else {
            // Desktop: keep zebra striping you had previously
            $(row).css({
              "background-color": index % 2 === 0 ? "#f7f7f7" : "#ffffff",
              color: "" // let default text color apply
            });
          }
        }
      });
    } catch (error) {
      console.error("Error initializing DataTable:", error);
      return;
    }

    // Helper: find hidden columns for a row (used for child details)
    const getHiddenColumnsForRow = (tr) => {
      const hiddenCols = [];
      $(tr)
        .find("td")
        .each((i, td) => {
          if ($(td).css("display") === "none" || $(td).is(":hidden"))
            hiddenCols.push(i);
        });
      return hiddenCols;
    };

    //mobile view
    // Build hidden row details (same as your previous implementation)
    const buildHiddenDetails = (rowData, tr) => {
      const settings = dt.settings()[0];
      const hiddenCols = getHiddenColumnsForRow(tr);
      if (!hiddenCols.length || hiddenCols.length === normalizedCols.length)
        return "";
      let html = "";
      hiddenCols.forEach((i) => {
        console.log("i:", i);
        const col = dt.column(i);
        console.log("col:", col);
        console.log("Row Data:", rowData);
        console.log("Normalized Cols:", normalizedCols);
        if (!col || !col.header()) return;

        const title = $(col.header()).text();
        const colDef = normalizedCols[i];
        const rawVal = rowData[colDef.data];

        // IMPORTANT: Use the same render() as parent column
        const rendered = colDef.render
          ? colDef.render(rawVal, "display", rowData, { row: 0, col: i })
          : rawVal ?? "";

        console.log("rendered:", rendered);

        html += `
      <tr>
        <td style="width:40%;border-top:0;border-left:0;border-right:0;border-bottom:1px solid #eee;">
          <span style="font-weight:bold;">${title}</span> 
          ${rendered}
        </td>
      </tr>`;
      });
      return html;
    };

    // Update toggle button / child rows as before
    const updateToggleButtons = () => {
      if (!$.fn.dataTable.isDataTable($table)) return;
      dt.rows().every(function () {
        const tr = $(this.node());
        const $btn = tr.find("button.toggle-row");
        const hiddenCols = getHiddenColumnsForRow(tr);
        const anyHidden =
          hiddenCols.length > 0 && hiddenCols.length < normalizedCols.length;
        if (anyHidden) {
          $btn.show();
          if (defaultExpand && !this.child.isShown()) {
            const details = buildHiddenDetails(this.data(), tr);
            if (details.trim()) {
              this.child(
                `<table class="table table-sm mb-0">${details}</table>`
              ).show();
              tr.addClass("shown");
              $btn
                .text("−")
                .removeClass("toggle-closed")
                .addClass("toggle-open");
            }
          } else if (this.child.isShown()) {
            const newDetails = buildHiddenDetails(this.data(), tr);
            this.child(
              `<table class="table table-sm mb-0">${newDetails}</table>`
            ).show();
          }
        } else {
          $btn.hide();
          if (this.child && this.child.isShown()) {
            this.child.hide();
            tr.removeClass("shown");
          }
        }
      });
    };

    $table.on("click", "button.toggle-row", function () {
      const tr = $(this).closest("tr");
      const row = dt.row(tr);
      const hiddenCols = getHiddenColumnsForRow(tr);
      if (!hiddenCols.length || hiddenCols.length === normalizedCols.length)
        return;
      if (row.child.isShown()) {
        row.child.hide();
        tr.removeClass("shown");
        $(this).text("+").removeClass("toggle-open").addClass("toggle-closed");
      } else {
        const details = buildHiddenDetails(row.data(), tr);
        if (!details.trim()) return;
        row
          .child(`<table class="table table-sm mb-0">${details}</table>`)
          .show();
        tr.addClass("shown");
        $(this).text("−").removeClass("toggle-closed").addClass("toggle-open");
      }
    });

    // --------- Core: renumber seq column on order/search/draw ----------
    const renumberSeq = () => {
      // rows in current ordering (includes all rows, not just current page)
      const nodes = dt.rows({ order: "applied" }).nodes();
      $(nodes).each((index, rowNode) => {
        // update the first cell's .seq-number text
        const $firstCell = $(rowNode).find("td").eq(0);
        const $span = $firstCell.find(".seq-number");
        if ($span.length) {
          $span.text(index + 1);
        } else {
          // fallback: if render didn't produce span, set plain text
          $firstCell.text(index + 1);
        }
      });
    };

    // call renumberSeq after draw/order/search
    dt.on("order.dt search.dt draw.dt", () => {
      try {
        renumberSeq();
        updateToggleButtons();
      } catch (e) {
        // swallow safe errors
        console.warn("Renumber/Toggle update failed:", e);
      }
    });

    // Initial numbering (after initial draw)
    requestAnimationFrame(() => {
      renumberSeq();
      updateToggleButtons();
    });

    const safeRecalc = () => {
      if (!$.fn.dataTable.isDataTable($table)) return;
      clearTimeout(window.__dt_safe_timer);
      window.__dt_safe_timer = setTimeout(() => {
        try {
          dt.responsive.recalc();
          requestAnimationFrame(() => updateToggleButtons());
        } catch (err) {
          console.warn("Resize skip:", err);
        }
      }, 30);
    };

    dt.on("responsive-resize draw", safeRecalc);
    window.addEventListener("resize", safeRecalc);

    return () => {
      window.removeEventListener("resize", safeRecalc);
      clearTimeout(window.__dt_safe_timer);
      $table.off("click", "button.toggle-row");
      if ($.fn.dataTable.isDataTable($table)) {
        try {
          const dtInstance = $table.DataTable();
          if (dtInstance) {
            dtInstance.off("order.dt search.dt draw.dt");
            dtInstance.off("responsive-resize draw");
            dtInstance.destroy(true);
          }
        } catch (error) {
          console.warn("Error during DataTable cleanup:", error);
        }
      }
    };
  }, [cols, betList, pageSize, defaultExpand, isLoading]);

  const getSize = (item) => {
    let str = "";
    if (
      item.type == "b" ||
      item.type == "y" ||
      item.type == "B" ||
      item.type == "Y"
    ) {
      str = `<span style="color:black">${item.lib}</span>`;
    } else {
      str = `<span style="color:black">${item.amnt}</span>`;
    }

    return str;
  };
  const getWinLoss = (item) => {
    console.log("item->", item);
    let str = "";
    if (item.is_loss != null && item.is_loss != undefined) {
      if (item.is_loss == 1) {
        if (
          item.type == "b" ||
          item.type == "y" ||
          item.type == "B" ||
          item.type == "Y"
        ) {
          str = `<span style="color:red">${item.lib}</span>`;
        } else {
          str = `<span style="color:red">${item.lib}</span>`;
        }
      } else {
        if (
          item.type == "b" ||
          item.type == "y" ||
          item.type == "B" ||
          item.type == "Y"
        ) {
          str = `<span style="color:green">${item.amnt}</span>`;
        } else {
          str = `<span style="color:green">${item.lib}</span>`;
        }
      }
    } else {
    }

    return str;
  };

  return (
    <div className="container-fluid" style={{ background: "#fff" }}>
      <div
        className="animated fadeIn"
        style={{
          margin: "0px",
          border: "1px solid #e2e2e2",
          borderRadius: "4px 4px 0px 0px",
        }}
      >
        <div className="col-12" style={{ padding: "0px" }}>
          <div className="card-header">
            <h3>{displayTitle}</h3>
          </div>
          <div className="card-body">
            <div
              className="row mb-3"
              style={{ display: "-webkit-box", marginBottom: "10px" }}
            >
              <div className="col-4 col-md-4">
                Winner
                <span
                  className="badge badge-warning ml-2"
                  style={{
                    fontSize: "100%",
                    background: "#ffc403",
                    color: "black",
                    padding: "4px",
                    borderRadius: "4px",
                  }}
                >
                  {resultValue}
                </span>
              </div>
              <div className="col-4 col-md-4">
                Net PL
                <span
                  style={{
                    fontSize: "100%",
                    background: winAmount >= 0 ? "#02b181" : "red",
                    color: "white",
                    padding: "4px",
                    borderRadius: "4px",
                  }}
                >
                  {winAmount}
                </span>
              </div>
              <div className="col-4 col-md-4">
                UserName
                <span
                  className="ml-2 badge badge-warning"
                  style={{
                    fontSize: "100%",
                    background: "#ffc403",
                    color: "black",
                    padding: "4px",
                    borderRadius: "4px",
                  }}
                >
                  {username}
                </span>
              </div>
            </div>

            <table
              ref={gridTableRef}
              id="betDetailsTable"
              className="table table-striped table-bordered"
            >
              <thead>
                <tr>
                  <th>Runner</th>
                  <th>Price</th>
                  <th>Size</th>
                  <th>Side</th>
                  <th>P/L</th>
                  <th>Placed At</th>
                  <th>Matched At</th>
                  <th>Settled At</th>
                  <th>Order-ID</th>
                </tr>
              </thead>
              <tbody />
            </table>
          </div>
        </div>
      </div>
      <style>{`
  .table { width: 100% !important; }
  .table.table-striped td, .table.table-striped th {
    padding: 6px 8px !important;
    font-size:17px;
    white-space: nowrap;
    vertical-align: middle;
  }
  table.table-sm td { padding: 4px 6px !important; }
  tr.shown + tr > td { background-color: #fafafa; }
  .seq-cell { display:flex; align-items:center; gap:6px; }
  .toggle-row {
    border: none;
    outline: none;
    cursor: pointer;
    width: 28px;
    height: 28px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    font-weight: 700;
    font-size: 16px;
    color: #fff;
    line-height: 1;
  }
  .toggle-closed { background-color: #28a745; }
  .toggle-open { background-color: #dc3545; }
  .toggle-row:active { transform: scale(0.94); }
  .dt-info { float:none !important; text-align:center !important; }
  .dt-paging-button { margin-left:0 !important; padding: 0 !important; }
  .dt-paging { text-align:center !important; }
  .pagination { display:block !important; }

  .table-striped tbody tr:nth-of-type(odd) { background-color: transparent; }
  .table tr:nth-child(even) { background-color: transparent; }

  table.dataTable.order-column tbody tr > .sorting_1,
  table.dataTable.order-column tbody tr > .sorting_2,
  table.dataTable.order-column tbody tr > .sorting_3,
  table.dataTable.display tbody tr > .sorting_1,
  table.dataTable.display tbody tr > .sorting_2,
  table.dataTable.display tbody tr > .sorting_3 {
    background-color: transparent;
  }

  .toggle-row { width:15px; height:15px; margin-left:2px; }

  .dt-search { float:right; padding-right:10px; }
  .dt-search .form-control{
    border: 1px solid #000;
    margin-bottom:5px;
  }

  .actionBtn {
    position: absolute;
    width: 100%;
    margin-top: 20px;
    z-index: 10;
  }

  /* MOBILE ONLY FIXES */
  @media screen and (max-width: 640px) {

    .actionBtn {
      width: 100%;
      margin-top: 20px;
      position: relative;
    }

    .dt-search {
      display: flex !important;
      align-items: center !important;
      gap: 8px !important;
      margin-top: 10px !important;
      float:none !important;
      justify-content:center;
    }

    .dataTable {
      margin-top:10px !important;
    }

    .table-responsive {
      margin-top:0px !important;
    }

    .dt-buttons {
      margin: 0 auto !important;
      float: none !important;
      width: auto !important;
      display: flex !important;
      justify-content: center;
    }
      
  }
        .dt-search {
      display: flex !important;
      align-items: center !important;
      gap: 8px !important;
      margin-top: 10px !important;
      float:none !important;
      justify-content:center;
    }
      @media screen and (max-width: 640px) {
  /* Make the top area stack nicely */
  .top.d-flex {
    flex-direction: column;
    align-items: center;
    gap: 8px;
  }

  /* Center the search container */
  .dt-search {
    display: flex !important;
    justify-content: center !important; /* center horizontally */
    width: 100% !important;
    margin: 8px 0 !important;
    padding: 0 12px;
    box-sizing: border-box;
  }

  /* Ensure the label + input stay inline and centered */
  .dt-search .dataTables_filter,
  .dataTables_filter {
    display: inline-flex !important;
    align-items: center !important;
    gap: 8px !important;
    justify-content: center;
    width: auto !important;
    margin: 0;
  }

  /* Limit input width so it doesn't push other controls */
  .dt-search input[type="search"],
  .dataTables_filter input[type="search"] {
    width: 160px !important;
    max-width: 80% !important;
    display: inline-block !important;
    margin: 0 !important;
  }
    .dt-container {
      margin-top:0px !important;
    }
    }
    .dataTable {
    margin-top:15px;
    }
`}</style>
    </div>
  );
};

export default BetDetailsPopup;
